/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SystemModule
 */

import { Component, Input } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';
import { IPortalConfiguration } from 'generated-types';
import { PortalConfiguration, SystemConfiguration } from 'object-types';
import { SystemConfig } from 'ajs/modules/system/factories/system-config.item.factory';
import * as l10n from './system-settings-access-config-container.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Component for Access Config System Settings Modal.
 * @author Kondiparthi Shanmukha Sarath
 */
@Component({
    selector: 'system-settings-access-config-container',
    templateUrl: './system-settings-access-config-container.component.html',
})
export class SystemSettingsAccessConfigContainerComponent {
    @Input()
    public editable: SystemConfig;

    @Input()
    public portalConfig: IPortalConfiguration;

    public readonly l10nKeys = l10nKeys;

    public readonly objectTypes = {
        PortalConfiguration,
        SystemConfiguration,
    };

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }
}
